@if (ticket$ | async; as ticket) {
  <div
    class="detailed-list-container"
    [ngClass]="{ 'no-working-periods': ticket.workPeriods.length <= 0 }"
  >
    @if (ticket.workPeriods.length <= 0) {
      <p>{{ 'noWorkPeriodRecorded' | i18nextCap }}</p>
    }
    @for (
      workingPeriod of ticket.workPeriods;
      track workingPeriod;
      let i = $index
    ) {
      <div class="detailed-list-item">
        <div class="detailed-list-item-details">
          <mat-icon>work_history</mat-icon>
          <div class="info">
            <span class="title mat-body-1 color-grey-600">
              @let startDate = workingPeriod.startingHour | date: 'dd/MM/yyyy';
              @let endDate = workingPeriod.endingHour | date: 'dd/MM/yyyy';
              @let formattedDuration =
                parseToTimeString(
                  timezoneDate.getTimeDiff(
                    workingPeriod.startingHour,
                    workingPeriod.endingHour
                  )
                );
              {{ startDate }}{{ startDate !== endDate ? ' - ' + endDate : '' }}
            </span>
            <div class="subtitle">
              <crm-assignees-icon-list
                [assignees]="parseAssignees(workingPeriod)"
                [size]="18"
                [maxDisplay]="4"
              ></crm-assignees-icon-list>
              <span class="color-grey-400">
                <mat-icon class="color-grey-500">schedule</mat-icon>
                {{ formatTimeString(workingPeriod.startingHour) }}
                -
                {{ formatTimeString(workingPeriod.endingHour) }}
                ({{ formattedDuration }})
              </span>
            </div>
          </div>
        </div>
        <button
          class="d-flex justify-content-end delete-working-period"
          mat-icon-button
          (click)="handleDeleteWorkingPeriod(workingPeriod.id)"
          type="button"
        >
          <div class="icon red-icon">
            <fa-icon [icon]="faTrashCan"></fa-icon>
          </div>
        </button>
      </div>
    }
  </div>
}
<div class="add-period-container">
  <button mat-stroked-button type="button" color="primary" (click)="openForm()">
    <mat-icon>assignment_add</mat-icon>
    {{ 'add' | i18nextCap }}
  </button>
</div>
@if (workHistory$ | async; as workHistory) {
  @if (workHistory.total > 0) {
    <div class="working-period-worked">
      @for (
        assignee of workHistory.assigneesWork;
        track assignee;
        let i = $index
      ) {
        <div class="working-period-worked-row">
          <span class="xlight">
            {{ assignee.firstName }} {{ assignee.lastName }}
          </span>
          <span class="semi-bold color-grey-700">
            {{ parseToTimeString(assignee.total) }}
          </span>
        </div>
        <mat-divider></mat-divider>
      }
      <div class="working-period-worked-row total">
        <span class="bold">{{ 'total' | i18nextCap }}</span>
        <span class="bold">
          {{ parseToTimeString(workHistory.total) }}
        </span>
      </div>
    </div>
  }
}
